// extracted by mini-css-extract-plugin
module.exports = {"row":"TaMhtEditorTerms_row___B_If","terms":"TaMhtEditorTerms_terms__1bmmt","details":"TaMhtEditorTerms_details__2g6QW"};